<template>
  <div :class="theme === 'LIGHT' ? 'bg-white' : 'bg-[#191919] text-white'">
    <div class="text-center my-12" v-if="title">
      <h2 class="text-3xl font-medium">{{ title }}</h2>
    </div>

    <Carousel :totalItems="products.length" :theme="theme" v-slot={index,key}>
      <ProductCard class="lg:w-[240px]" :key="key" v-bind="products[index]" />
    </Carousel>
  </div>
</template>

<script setup lang="ts">
import Carousel from '~/components/ui/molecule/carousel/index.vue'
import ProductCard, {type ProductCardProps} from '~/components/ui/organism/product/deprecated-manual-card.vue'

interface ProductCarouselProps {
  title?: string;
  products: ProductCardProps[];
  theme?: "DARK" | "LIGHT";
}

const {products=[], theme="LIGHT", title} = defineProps<ProductCarouselProps>();

</script>